import { useLanguage } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { Check } from "lucide-react";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_lopez-designs/artifacts/d4h9j47v_oriol.jpeg";

const About = () => {
  const { t } = useLanguage();
  const imgRef = useReveal();
  const textRef = useReveal();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#F8F8F7] py-20 md:py-32 lg:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div
            ref={imgRef}
            className="reveal lg:col-span-5 relative"
          >
            <div className="relative overflow-hidden aspect-square">
              <img
                src={PORTRAIT}
                alt="Oriol López — Architect"
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                data-testid="about-portrait"
              />
            </div>
            {/* Accent block */}
            <div className="hidden md:block absolute -bottom-6 -right-6 w-32 h-32 border border-[#1A1A1A]" />
          </div>

          {/* Text */}
          <div
            ref={textRef}
            className="reveal lg:col-span-7 lg:pl-8"
          >
            <p className="text-[12px] sm:text-sm uppercase tracking-[0.28em] font-semibold text-[#52525B] mb-5 md:mb-6">
              — {t.about.overline}
            </p>
            <h2 className="font-serif text-[3.5rem] sm:text-5xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#1A1A1A] leading-[1.05] mb-6 md:mb-8">
              {t.about.title}
            </h2>
            <div className="space-y-5 mb-10 md:mb-12 max-w-xl">
              {t.about.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className="text-[1.18rem] sm:text-lg md:text-lg text-[#52525B] leading-relaxed"
                >
                  {p}
                </p>
              ))}
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl">
              {t.about.highlights.map((h, i) => (
                <li
                  key={h}
                  data-testid={`about-highlight-${i}`}
                  className="flex items-center gap-3 py-3 border-t border-[#E5E5E5]"
                >
                  <span className="w-7 h-7 sm:w-6 sm:h-6 flex items-center justify-center bg-[#1A1A1A] text-white shrink-0">
                    <Check strokeWidth={2.5} className="w-3.5 h-3.5 sm:w-3 sm:h-3" />
                  </span>
                  <span className="text-[1.1rem] sm:text-base text-[#1A1A1A] font-medium">
                    {h}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
